import { gql } from "@apollo/client";

export const GET_OBDSPEED = gql`
  query getObdDataPoints($uniqueId: String!, $from: String, $to: String) {
    getObdDataPoints(uniqueId: $uniqueId, from: $from, to: $to) {
      vehiclespeed
      obddistance
      ts
      mil
    }
  }
`

export const GET_ALL_GROUPS = gql`
  query {
    getAllGroups {
      id
      groupName
      assignedVehicles {
        vehicleNumber
      }
    }
  }
`

export const GET_DRIVER_BY_IMEI = gql`
  query findDriverByImei($imei: String!) {
    findDriverByImei(imei: $imei) {
      driverName
      contactNumber
      driverImage
      rfid
      responsibleName
      responsibleContactNumber
      lastRFID
    }
  }
`

export const GET_LATEST_LOCATION = gql`
  query getLatestLocation($uniqueId: String!) {
    latestLocation: getDeviceLatestLocation(deviceId: $uniqueId) {
      timestamp
      latitude
      longitude
      haltStatus
      idlingStatus
      isOverspeed
      speed
      extBatVol
      isPrimaryBattery
      isNoGps
      address
    }
  }
`

export const GET_ALL_TRIPS = gql`
  query getAllTrips(
    $clientLoginId: Int!
    $status: Int
    $uniqueDeviceId: String
    $cursor: String
    $limit: Int
  ) {
    getAllTrips(
      clientLoginId: $clientLoginId
      status: $status
      uniqueDeviceId: $uniqueDeviceId
      cursor: $cursor
      limit: $limit
    ) {
      totalCount
      edges {
        cursor
        node {
          tripName
          status
          fromTimestamp
          route {
            areaName
            places
          }
        }
      }
    }
  }
`

export const GET_ALL_ALERTS = gql`
  query getAllAlertsByAlertType(
    $clientId: Int!
    $alertType: String!
    $from: String
    $to: String
  ) {
    getAllAlertsByAlertType(
      clientLogin: $clientId
      alertType: $alertType
      from: $from
      to: $to
    ) {
      alerttype
      alertvalue
      vehicleNumber
      to_ts
      address
      lat
      lng
    }
  }
`

//tous les aoi
export const GET_ALL_AOI = gql`
  query getAllAreaDetails($clientLoginId: Int!) {
    getAllAreaDetails(clientLoginId: $clientLoginId) {
      geoJson
      updatedAt
    }
  }
`

export const GET_DRIVER_DETAILS = gql`
  query getDriverDetails($uniqueDeviceId: String) {
    getDriverDetails(uniqueDeviceId: $uniqueDeviceId) {
      driverName
      contactNumber
      driverImage
      rfid
    }
  }
`
export const GET_VEHICLE_DETAILS = gql`
  query getVehicleDetail($vehicleNumber: String) {
    getVehicleDetail(vehicleNumber: $vehicleNumber) {
      device {
        imei_num
      }
    }
  }
`
export const GET_DRIVER_DETAILS_BY_IMEI_RFID = gql`
  query findDriverDetailsByImeiAndRfid($imei: String!, $rfid: String) {
    findDriverDetailsByImeiAndRfid(imei: $imei, rfid: $rfid) {
      data {
        image
        name
        phone
      }
    }
  }
`

export const GET_LTM_AOI_RFID_EVENTS = gql`
  query getLtmAoiRfidEvents($uniqueid: String, $aoiId: Int) {
    getLtmAoiRfidEvents(uniqueid: $uniqueid, aoiId: $aoiId) {
      id
      uniqueid
      aoiId
      partnerId
      partnerName
      lat
      lng
      ts
    }
  }
`

/**
 * @summary Fetches all devices with their latest locations
 */
export const GET_ALL_DEVICES = gql`
  query getDevices {
    devices: getAllDeviceLocations {
      isNoGps
      isOffline
      speed
      uniqueId
      vehicleNumber
      vehicleType
      vehicleModel
      model_name
      timestamp
      latitude
      longitude
      haltStatus
      idlingStatus
      isOverspeed
      isPrimaryBattery
      extBatVol
      vehicleGroups
      address
    }
  }
`

/**
 * @summary Get all points of a vehicle between two timestamps
 */
export const TRAVEL_REPLAY_PACKETS = gql`
  query(
    $uniqueId: String!
    $from: String!
    $to: String!
    $snapToRoad: Boolean
  ) {
    getTravelHistory(
      uniqueId: $uniqueId
      from: $from
      to: $to
      snapToRoad: $snapToRoad
    ) {
      distanceTravelledKms
      points {
        ts
        lat
        lng
        speed
        isHA
        isHB
        address
      }
    }
  }
`
/**
 * @summary Subscription used to get live location data for a vehicle
 */
export const DEVICE_LOCATION = gql`
  subscription liveTrackingData($deviceId: String!, $snapToRoad: Boolean!) {
    deviceLiveTracking(deviceId: $deviceId, snapToRoad: $snapToRoad) {
      timestamp
      latitude
      longitude
      haltStatus
      idlingStatus
      isOverspeed
      speed
      extBatVol
      isPrimaryBattery
      isNoGps
      address
    }
  }
`
